/**
 * Enum para los diferentes estados de cotización en pausa
 * Cada estado tiene un código numérico asociado
 */
export enum CotizacionPausaEstado {
  /** Cotización en Pausa - Lead Falla Runt */
  LEAD_FALLA_RUNT = 20,

  /** Cotización en Pausa - Lead falla servicio Fasecolda */
  LEAD_FALLA_SERVICIO_FASECOLDA = 71,

  /** Cotización en Pausa - Lead propietario persona jurídica */
  LEAD_PROPIETARIO_PERSONA_JURIDICA = 54,

  /** Cotización en Pausa - Lead uso Comercial */
  LEAD_USO_COMERCIAL = 53,

  LEAD_PRENDA_SI = 63,

  INFORMACION_RUNT_DESACTUALIZADA = 79,

  VALIDACION_SALVAMENTO = 80,

  /** Cotización en Pausa - Lead falla técnica cotizador */
  FALLA_TECNICA_COTIZADOR = 100,



  VALIDACION_MOVILIDAD_FALLIDA = 56,

  VALIDACION_COMBUSTIBLE_FALLIDA = 49

}

/**
 * Mapeo de códigos a descripciones legibles
 */
export const CotizacionPausaDescripciones: Record<CotizacionPausaEstado, string> = {
  [CotizacionPausaEstado.LEAD_FALLA_RUNT]: 'Cotización en Pausa - Lead Falla Runt',
  [CotizacionPausaEstado.LEAD_FALLA_SERVICIO_FASECOLDA]: 'Cotización en Pausa - Lead falla servicio Fasecolda',
  [CotizacionPausaEstado.LEAD_PROPIETARIO_PERSONA_JURIDICA]: 'Cotización en Pausa - Lead propietario persona jurídica',
  [CotizacionPausaEstado.LEAD_USO_COMERCIAL]: 'Cotización en Pausa - Lead uso Comercial',
  [CotizacionPausaEstado.FALLA_TECNICA_COTIZADOR]: 'Cotización en Pausa - Lead falla técnica cotizador',
  [CotizacionPausaEstado.LEAD_PRENDA_SI]: 'Cotización en Pausa - Lead prenda_si',
  [CotizacionPausaEstado.INFORMACION_RUNT_DESACTUALIZADA]: 'Información del Runt Desactualizada',
  [CotizacionPausaEstado.VALIDACION_MOVILIDAD_FALLIDA]: 'Cotización en Pausa - Políticas de Negocio Fallidas',
  [CotizacionPausaEstado.VALIDACION_SALVAMENTO]: 'Cotización en Pausa - No pasa validacion de siniestro',
  [CotizacionPausaEstado.VALIDACION_COMBUSTIBLE_FALLIDA]: 'Cotización en Pausa - No pasa validación de tipo de combustible'
};